import React, {ReactElement} from 'react';
import Props from './typings';
import StyledSize from './styles';

const Size = ({size, label, active, disabled = false, onClick}: Props): ReactElement => {
  return (
    <StyledSize $size={size} $active={active} onClick={onClick} $disabled={disabled}>
      <button>{size}</button>
      <span>{label}</span>
    </StyledSize>
  );
};

export default Size;
